import {
  CloudArrowUpIcon,
  CurrencyDollarIcon,
  GraphIcon,
  KeyboardIcon,
  KeyIcon,
  UserGroupIcon,
  UserIcon,
} from "@stacklet/ui";

import { useConfig } from "app/contexts/ConfigContext";
import { useHasScopePermission } from "app/hooks";

export function useSettingsBreadcrumbs() {
  const config = useConfig();
  const hasPermission = useHasScopePermission();
  const isAdmin = hasPermission("system", "EDIT");

  const adminTabs = isAdmin
    ? [
        {
          label: "Identity Providers",
          id: "settings-identity-providers",
          target: "/settings/access-control/identity-providers",
          section: "Users & Groups",
          icon: KeyIcon,
        },
        {
          label: "Users",
          id: "settings-users",
          target: "/settings/access-control/users",
          section: "Users & Groups",
          icon: UserIcon,
        },
        {
          label: "Groups",
          id: "settings-groups",
          target: "/settings/access-control/groups",
          section: "Users & Groups",
          icon: UserGroupIcon,
        },
        ...(config?.dev_flags.includes("admin-settings")
          ? [
              {
                label: "Access Model",
                target: "/settings/access-model",
                section: "Clouds & Integrations",
                icon: KeyboardIcon,
              },
            ]
          : []),
        {
          label: "Clouds",
          target: `/settings/clouds`,
          section: "Clouds & Integrations",
          icon: CloudArrowUpIcon,
        },
        {
          label: "Cost",
          target: `/settings/cost`,
          section: "Clouds & Integrations",
          icon: CurrencyDollarIcon,
        },
        {
          label: "Integrations",
          target: `/settings/integrations`,
          section: "Clouds & Integrations",
          icon: GraphIcon,
        },
      ]
    : [];

  return [{ label: "Settings" }, { tabs: adminTabs }];
}
